// extracted by mini-css-extract-plugin
export var createdDate = "_h2-1";
export var divider = "_h2-2";
export var headerDivider = "_h2-3";
export var messagesCard = "_h2-0";
export var messagesContainer = "_h2-6";
export var messagesContainerWrapper = "_h2-4";
export var showLeftPanelButton = "_h2-8";
export var topButtons = "_h2-7";
export var withPadding = "_h2-5";